import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import BeyondTheHorizon from "./sections/BeyondTheHorizon";
import TheSoundOfTheFuture from "./sections/TheSoundOfTheFuture";
import FreshDrops from "./sections/FreshDrops";
import JoinTheMovement from "./sections/JoinTheMovement";
import Footer from "@/reusable_sections/Footer";
import Logohero from "./sections/Logohero";
import Herohorizon from "./sections/Herohorizon";
export default function HomePage() {
  return <div>
      <Navigation />
      <BeyondTheHorizon />
      <Logohero />
      <Herohorizon />
      <TheSoundOfTheFuture />
      <FreshDrops />
      <JoinTheMovement />
      <Footer />
    </div>;
}